const state = {

    /** Array choix câble */
     cable : [] ,

}
const mutations = {


   /** Lsite pre panier */
   GET_CHOICE_CABLE(state, payload) {
    state.cable = payload;
  },
  /** Ajout au prePanier */
  SET_CHOICE_CABLE(state, payload) {
    this.newArray
    if( state.cable.length == 0 ){
      this.newArray = payload.cable
    }
    else{
      this.newArray = Object.assign(state.cable, payload.cable);
    }

    state.cable = this.newArray ;
  },

    /** Ajout au prePanier */
    PUT_CABLE_STRUCTURE(state, payload) {
      this.newArray
      if( state.cable.structure.length == 0 ){
        this.newArray = payload.cable.structure
      }
      else{
        this.newArray = Object.assign(state.cable.structure, payload.cable.structure);
      }
  
      state.cable.structure = this.newArray ;
    },


   /** Suppression ligne au prePanier */
   REMOVE_CHOICE_CABLE(state) {
    state.cable = []
},
  /** Suppression ligne au prePanier */
  DELETE_CHOICE_CABLE(state, payload) {

      const objWithIdIndex = state.StoreChoiceCable.findIndex((obj) => obj.id_perso === payload);
    
      if (objWithIdIndex > -1) {
        state.StoreChoiceCable.splice(objWithIdIndex, 1);
      }
    
  },
  /** Maj prePanier */
  PUT_CHOICE_CABLE(state, payload ) {

   var idtab = payload.id_perso;
   var value = payload.value;
   var libelle = payload.libelle_tab;
   
   var upd_obj = state.StoreShowPrePanierListe.findIndex((obj) => obj.id_perso === idtab) ;
    state.StoreShowPrePanierListe[upd_obj][libelle] = value ;
  },



}
export default {
    state,
    mutations,
}